module.exports = __webpack_public_path__ + "img/portable-speaker-1.66a52d47.png";